// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1d6dca75","455":"39d330de","977":"0a114741"}[chunkId] + ".chunk.js";
};